/**
 * 主页模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 经营统计
export const businessStatistical = (params) => {
  return req.get('/home/statistical', params);
}

// 医生数据
export const doctorData = (params) => {
  return req.get('/home/doctorPanel', params);
}

// 医馆数据
export const deptData = (params) => {
  return req.get('/home/deptPanel', params);
}

// 医保数据导入
export const yibaoUpLoad = (params) => {
  return req.post('/yb/drug/decoctionPieces/batch', params);
}

// 医生号源列表
export const registerListApi = (params) => {
  return req.post('/home/registerOverviewPage', params);
}
// 医生号源信息
export const registerInfoApi = (params) => {
  return req.post('/home/registerOverview', params);
}
//医生诊断看板
export const diagnoseOverviewApi = (params) => {
  return req.post('/home/diagnoseOverview', params);
}
//医生诊断列表
export const diagnoseOverviewListApi = (params) => {
  return req.post('/home/diagnoseOverviewPage', params);
}